module.exports = __webpack_public_path__ + "img/6523e4f7485a7697ac114d41_gdpr.03abb09f.webp";